export const environment = {
  production: false,
  apiUrl: 'https://fcr-admin-backend.onrender.com/api/'
  // apiUrl: 'http://127.0.0.1:8000/api/'
  // apiUrl: 'https://api.fcrtrades.io/sea/api/'
};